/**
 * Redux store configuration with RTK Query and auth slice.
 */

import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
// Side-effect imports: each module injects its endpoints into the shared
// apiSlice (and registers tags) at module load time.
import './api/communicationApi';
import './api/agentFactoryApi';
import './api/agentRuntimeApi';
import './api/organizationsApi';
import './api/rolesApi';
import './api/projectsApi';
import './api/approvalsApi';
import './api/secretsApi';
import './api/voiceApi';
import './api/daytonaApi';
import './api/bulkApi';
import './api/indexerApi';
import './api/repositoriesApi';
import './api/policyBuilderApi';
import './api/storageContentApi';
import './api/directoryApi';
import './api/customersApi';
import './api/simpleRolesApi';
import './api/resourceSharesApi';
import authReducer from './auth/authSlice';
import mfaReducer from './auth/mfaSlice';
import orgSessionReducer from './auth/orgSessionSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    mfa: mfaReducer,
    orgSession: orgSessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
